export default "__VITE_ASSET__39057460__"